/* Lightweight US-locale formatters used across the app. */

// ---------- Dates ----------
// All dates are stored as ISO ("YYYY-MM-DD") or ISO datetime strings.
// Display everywhere is MM/DD/YYYY (US).

export function formatDateUS(value) {
    if (!value) return "";
    // ISO date "YYYY-MM-DD" — render without timezone shifting
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split("-");
        return `${m}/${d}/${y}`;
    }
    const d = value instanceof Date ? value : new Date(value);
    if (!d || isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
}

// ---------- Phone numbers (US, 10-digit) ----------

// Strip every non-digit, then drop a leading "1" country code if present.
export function digitsOnly(raw) {
    const d = (raw || "").toString().replace(/\D+/g, "");
    return d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
}

// Returns "(555) 123-4567" for a 10-digit US number, or progressive partials
// while the user is still typing ("(555) 1", "(555) 123-4", etc.).
export function formatPhoneUS(raw) {
    const d = digitsOnly(raw).slice(0, 10);
    if (!d) return "";
    if (d.length < 4) return `(${d}`;
    if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

// Use when echoing back a stored phone string — same as formatPhoneUS but returns
// the original input if it doesn't parse to a 10-digit US number (e.g. international).
export function displayPhone(raw) {
    if (!raw) return "";
    const d = digitsOnly(raw);
    if (d.length !== 10) return raw;          // pass through non-US numbers as-is
    return formatPhoneUS(d);
}
